import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import * as s from "./Payment.module.scss";

export type PaymentItemType =
	| "afterpay"
	| "amex"
	| "mastercard"
	| "paypal"
	| "visa"
	| "klarna"
	| "stripe"
	| "swish"
	| "google-pay"
	| "google-pay-mark"
	| "apple-pay"
	| "r-pay"
	| "american-express";

type PaymentProps = PropsWithChildren<{
	priceModule?: boolean;
	className?: string;
}>;

const Payment: FC<PaymentProps> = ({ children, priceModule, className }) => {
	return (
		<div
			className={cn(s.container, className, {
				[s.priceModulestyle]: priceModule,
			})}
		>
			{children}
		</div>
	);
};
export default Payment;
